import {createContext} from 'react';

export type AccountingCalculationCacheValue = {
  taxDocumentCalculationCacheKey: string;
  accountingDocumentCalculationCacheKey: string;
};

export const AccountingCalculationCacheContext =
  createContext<AccountingCalculationCacheValue | null>(null);
